import type { TenantConfig } from '@/types/TenantConfig'

const darkBlue = '#243c94'
const grey = '#777679'
const purple = '#8b457f'
const blue = '#0071bc'
const green = '#40ae2a'

export const discoveryplace: TenantConfig = {
  logo: 'assets/discoveryplace/static/logo-2.svg',
  themeOptions: {
    primaryColor: darkBlue,
    secondaryColor: grey,
    logoHeight: '52px',
    cartHeaderBackgroundColor: blue,
    cartHeaderTextColor: 'white',
    headerHeight: '73px',
    memberLinksColor: darkBlue,
    headerDropShadow: '0 0 10px 0 rgba(0, 0, 0, 0.2)',
    infoColor: darkBlue,
    successColor: green,
    promoColor: purple,
  },
  componentOptions: {
    stripeCreditCard: {
      fontFaceStylesheet: '/assets/discoveryplace/static/fonts.css',
    },
    completedOrdersRoute: {
      completedImage: {
        desktop: 'assets/discoveryplace/static/completed.jpeg',
      },
      completedContentOffset: {
        desktop: '-300px',
        mobile: '-150px',
      },
    },
  },
}
